// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_1nVRq","title":"_2c2dZ","subContainer":"_2F9JF","text":"_16CNy","image":"_2x35A","textWithImage":"_33fbn"};